<template>
  <aw-modal
    :opened="opened"
    size="md"
    :closable="closable"
    :modal-title="title"
    @close-modal="closeModal"
  >
    <template #content>
      <div :class="$style.wrapper" aria-live="assertive">
        <aw-separator margin-top="none" />
        <aw-notification-item
          :notification="{
            type: 'info',
            iconName: 'education-16',
            manualClose: false,
            text: {
              subtitle: message
            }
          }"
          index="0"
          thick-content
        />
        <aw-separator />
        <slot name="actionButtons" />
      </div>
    </template>
  </aw-modal>
</template>

<script setup>
  import AwModal from '~~/common/components/Common/AwModal';

  import { useModalStore } from '~~/common/stores/modal';
  import AwSeparator from '~~/common/components/Common/AwSeparator.vue';
  import AwNotificationItem from '~~/common/components/Common/AwNotificationItem.vue';


  const props = defineProps({
    title: {
      type: String,
      default: '',
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  });

  const emits = defineEmits([
    'close-modal',
  ]);

  const modal = computed(() => {
    return useModalStore().activeGenericModal;
  });

  const opened = computed(() => {
    return modal.value.type === props.type;
  });

  const closable = computed(() => {
    return modal.value.closable;
  });

  function closeModal () {
    emits('close-modal');
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
</style>
